import Vue from 'vue';

import { getCurRegion } from './multiRegionUtil';

// 分市场状态转换, 原状态: 新状态
const statusMapping = {
  BR: {},
};

export function getMapping(val: string, mapping: any) {
  const region = getCurRegion();
  if (!mapping || !mapping[region]) return val;
  return mapping[region][val] || val;
}

export function getStatusMapping(status: string, prefixByTransify: string) {
  // 防止拿不到翻译值，将key直接显示在页面的判断
  if (!prefixByTransify) {
    return getMapping(status, statusMapping);
  }

  const dividerSymbol = '.';
  const transifyStatus = Vue.prototype.$t(`${prefixByTransify}${dividerSymbol}${status}`);
  if (!transifyStatus || transifyStatus.includes(dividerSymbol)) {
    return status;
  }

  return transifyStatus;
}
